// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchBox_searchBox__IIBJX","searchBoxInput":"SearchBox_searchBoxInput__VuydT","fullWidth":"SearchBox_fullWidth__G0faw"};